import React from 'react';
import { useSelector } from 'react-redux';

// utils
import { fieldExistsInConfig } from '../../../utils/form';

// components
import { YesNo, TextInput, TextBlock } from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

function OtherCoverage() {
  const {
    values: {
      otherrxcov,
      othercoverage,
      onmedicaid,
    },
    form: { form },
  } = useSelector(store => store);

  // const medicaidNumExistsInConfig = fieldExistsInConfig(form, 'medicaidnum');
  const otherCoverageExists = fieldExistsInConfig(form, 'othercoverage');
  const otherRXCoverageExists = fieldExistsInConfig(form, 'otherrxcov');

  return (
    <div>
      {/* Other RX Coverage */}
      <FormRow hide={!otherRXCoverageExists}>
        <YesNo
          label="Once you're enrolled, will you or your spouse have other RX coverage (like VA or TRICARE)?"
          name="otherrxcov"
          unsetFieldsOnFalse={[
            'otherrxcov_name',
            'otherrxcov_id',
            'otherrxcov_num',
          ]}
        />
      </FormRow>
      <Collapse indent isOpen={otherrxcov} recalculateHeightOnChange={otherrxcov}>
        <FormRow>
          <TextInput
            label="What is the name of the other RX coverage?"
            name="otherrxcov_name"
            className="mb-3"
          />
          <YesNo
            label="What is your member ID?"
            name="otherrxcov_id"
            className="mb-3"
          />
          <TextInput
            label="What is the policy number?"
            name="otherrxcov_num"
            className="mb-3"
          />
          <TextInput
            label="What is the group number?"
            name="otherrxcov_group_num"
            className="mb-3"
          />
        </FormRow>
      </Collapse>

      {/* Other Coverage */}
      <FormRow hide={!otherCoverageExists}>
        <YesNo
          label="Once you're enrolled, will you or your spouse have other group health coverage?"
          name="othercoverage"
          unsetFieldsOnFalse={[
            'othercoverage_name',
            'othercoverage_num',
            'othercoverage_id',
            'othercoverage_rx',
            'othercoverage_group',
          ]}
        />
      </FormRow>
      <Collapse indent isOpen={othercoverage} recalculateHeightOnChange={othercoverage}>
        <FormRow>
          <TextInput
            label="What is the name of the other coverage?"
            name="othercoverage_name"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="What is the policy number?"
            name="othercoverage_num"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="What is your member ID?"
            name="othercoverage_id"
          />
        </FormRow>
        <FormRow>
          <YesNo
            label="Does your other coverage include RX coverage?"
            name="othercoverage_rx"
          />
        </FormRow>
        <FormRow className="mb-0">
          <TextInput
            label="What is the group number of your other coverage"
            name="othercoverage_group"
          />
        </FormRow>
      </Collapse>

      {/* Will Work */}
      <FormRow>
        <YesNo
          label="Once you're enrolled will you work?"
          name="willwork"
        />
      </FormRow>

      {/* Will Spouse Work */}
      <FormRow>
        <YesNo
          label="Once you're enrolled will your spouse work?"
          name="willworkspouse"
        />
      </FormRow>

      {/* Skilled Nursing */}
      <FormRow showIfFieldExists="skilled_nursing">
        <YesNo
          label="Skilled nursing"
          name="skilled_nursing"
        />
      </FormRow>

      {/* Continuity Care */}
      <FormRow showIfFieldExists="continuity_care">
        <YesNo
          label="Continuity of care"
          name="continuity_care"
        />
      </FormRow>

      {/* On Medicaid */}
      <FormRow>
        <YesNo
          label="Are you currently on state Medicaid?"
          name="onmedicaid"
          unsetFieldsOnFalse={[ 'medicaidnum' ]}
        />
      </FormRow>

      <Collapse indent isOpen={onmedicaid} recalculateHeightOnChange={onmedicaid}>
        <FormRow showIfFieldExists="medicaidnum">
          <TextInput name="medicaidnum" />
        </FormRow>
        <FormRow showIfFieldExists="medicaid_additional_desc" className="mb-0">
          <TextBlock name="medicaid_additional_desc" />
        </FormRow>
        <FormRow showIfFieldExists="medicaid_accessnum">
          <TextInput name="medicaid_accessnum" />
        </FormRow>
        <FormRow showIfFieldExists="medicaid_casenum">
          <TextInput name="medicaid_casenum" />
        </FormRow>
      </Collapse>
    </div>
  );
}

export default OtherCoverage;
